export const cardData = [
  {
    title: "Setup",
    subtitle: "react",
    filepath: "/learning/setup.md",
    content:
      "The MERN stack is a popular web development stack that consists of MongoDB, Express.js, React.js, and Node.js.",
  },
  {
    title: "Redux",
    subtitle: "react - redux",
    filepath: "/learning/redux.md",
    content:
      "The MERN stack is a popular web development stack that consists of MongoDB, Express.js, React.js, and Node.js.",
  },
  // 🔹 React Core Concepts
  {
    title: "MERN Stack APP",
    subtitle: "MongoDB, Express, React, Node.js",
    filepath: "/learning/simple-app.md",
    content:
      "The MERN stack is a popular web development stack that consists of MongoDB, Express.js, React.js, and Node.js.",
  },
  {
    title: "File Structure",
    subtitle: "React + TypeScript Best Practices",
    filepath: "/learning/1-files-structure.md",
    content:
      "Learn how to structure your React app with folders like components, pages, hooks, and assets for better scalability.",
  },
  {
    title: "Array Methods",
    subtitle: "Using `.map()`, `.filter()`, `.reduce()`",
    filepath: "/learning/2-array-methods.md",
    content:
      "These methods are essential for rendering lists, filtering data, and transforming arrays in React apps.",
  },
  {
    title: "React Render",
    subtitle: "How React Renders Components",
    filepath: "/learning/3-React-render.md",
    content:
      "Understand how virtual DOM, reconciliation, and re-renders work to optimize your component performance.",
  },
  {
    title: "Components",
    subtitle: "Functional & Class Components",
    filepath: "/learning/4-components.md",
    content:
      "React is built around components. Learn how to build UI using reusable, composable functional components.",
  },
  {
    title: "Lifecycle",
    subtitle: "React Component Lifecycle",
    filepath: "/learning/5-lifecycle.md",
    content:
      "Understand mounting, updating, and unmounting phases, and how lifecycle methods work under the hood.",
  },
  {
    title: "Events",
    subtitle: "React Component Events",
    filepath: "/learning/6-events.md",
    content:
      "Learn how to handle events in React components, including synthetic events and event delegation.",
  },
  {
    title: "Lists",
    subtitle: "React lists and keys",
    filepath: "/learning/7-lists.md",
    content:
      "Learn how to render lists of items in React using the `.map()` method and the importance of keys.",
  },
  {
    title: "Router",
    subtitle: "React Router",
    filepath: "/learning/8-router.md",
    content:
      "Learn how to use React Router for navigation and routing in your React applications.",
  },
  {
    title: "Memo",
    subtitle: "React memo()",
    filepath: "/learning/9-memo.md",
    content:
      "Learn how to use React Router for navigation and routing in your React applications.",
  },

  // 🔹 React Hooks
  {
    title: "useState",
    subtitle: "React Hook",
    filepath: "/hooks/2-UseState.md",
    content:
      "Lets you declare state in functional components. It's the most basic and frequently used hook.",
  },
  {
    title: "useEffect",
    subtitle: "React Hook",
    filepath: "/hooks/3-UseEffect.md",
    content:
      "Used for side effects like data fetching, subscriptions, and manually changing the DOM after render.",
  },
  {
    title: "useRef",
    subtitle: "React Hook",
    filepath: "hooks/5-UseRef.md",
    content:
      "Allows you to reference DOM elements or persist values across renders without triggering re-renders.",
  },
  {
    title: "useContext",
    subtitle: "React Hook",
    filepath: "hooks/4-UseContext.md",
    content:
      "Provides a way to pass data deeply through the component tree without props drilling.",
  },
  {
    title: "useMemo",
    subtitle: "React Hook",
    filepath: "/hooks/8-UseMemo.md",
    content:
      "Memoizes expensive calculations so they’re not re-run unnecessarily on every render.",
  },
  {
    title: "useCallback",
    subtitle: "React Hook",
    filepath: "/hooks/9-UseCallBack.md",
    content:
      "Returns a memoized version of a callback that only changes if one of the dependencies has changed.",
  },
  {
    title: "useReducer",
    subtitle: "React Hook",
    filepath: "/hooks/6-UseReducer.md",
    content:
      "Alternative to `useState` for managing complex state logic in components.",
  },
  {
    title: "useLoc",
    subtitle: "React UseLoc",
    filepath: "/hooks/useLoc.md",
    content:
      "Alternative to `useState` for managing complex state logic in components.",
  },
  {
    title: "Custom Hooks",
    subtitle: "Your Own Hooks",
    filepath: "/hooks/1-hook.md",
    content:
      "You can extract and reuse logic across components by writing your own custom hooks.",
  },
  {
    title: "React  API",
    subtitle: "React API",
    filepath: "/learning/api.md",
    content:
      "Learn about the React API, including `createElement`, `cloneElement`, and `isValidElement`.",
  },
];
